var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExhibitions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 101,
    viewBox: "0 0 99 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.145 70.5746C66.68 95.2112 31.192 95.0732 11.856 70.5746L11.4615 71.1811L11.7583 74.6458C31.9383 97.5106 66.1293 97.4233 86.2353 74.6577L86.5322 70.9195L86.145 70.5746Z",
    fill: "url(#paint0_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.41 66.2139C95.3358 71.6012 87.3709 71.6012 87.3084 66.2139C87.4451 60.795 95.2732 60.795 95.41 66.2139Z",
    fill: "url(#paint1_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.328 94.4146H87.4022L89.1092 72.6915C90.578 73.1791 92.1639 73.1949 93.6209 72.6796L95.328 94.4146Z",
    fill: "url(#paint2_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5 98.279V100.574H84.234V98.279C84.234 97.6606 84.7223 97.1651 85.3317 97.1651H97.4017C98.0111 97.1651 98.5 97.6606 98.5 98.279Z",
    fill: "url(#paint3_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.691 66.2139C10.6207 71.6051 2.64799 71.5893 2.58939 66.2139C2.72611 60.795 10.5542 60.795 10.691 66.2139Z",
    fill: "url(#paint4_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.766 98.279V100.574H-0.5V98.279C-0.5 97.6606 -0.01172 97.1651 0.5977 97.1651H12.6677C13.2771 97.1651 13.766 97.6606 13.766 98.279Z",
    fill: "url(#paint5_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.598 94.4146H2.67221L4.37921 72.6752C5.84011 73.1945 7.42611 73.1707 8.89091 72.6871L10.598 94.4146Z",
    fill: "url(#paint6_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5 0.246731L10.582 0.203125C10.5625 0.452861 -0.0509914 40.3198 0.0270086 40.5461L98.011 40.6135C98.1477 40.4073 87.491 0.46536 87.499 0.247175L87.5 0.246731ZM91.9961 35.8688C91.6992 36.2533 91.25 36.4872 90.7617 36.4872H7.26171C6.28515 36.507 5.48831 35.4605 5.77341 34.5091L13.3593 5.49959C13.5507 4.8138 14.1601 4.33022 14.8632 4.33022H83.1752C83.8783 4.33022 84.4877 4.80989 84.6674 5.48376L92.269 34.5095C92.3901 34.9892 92.293 35.4843 91.9961 35.8688Z",
    fill: "url(#paint7_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.281 7.0769H15.758L8.7814 33.7391H89.2614L82.281 7.0769ZM22.207 19.0406L23.5195 12.9754C23.75 11.9289 24.6445 11.2034 25.6875 11.2034H72.3515C73.3945 11.2034 74.289 11.9328 74.5195 12.9754L75.8359 19.0406C76.1523 20.3923 75.0507 21.8155 73.6679 21.7758H24.3789C22.9961 21.8115 21.8867 20.3923 22.207 19.0406ZM77.242 28.8439H20.797C19.0431 28.8518 19.0079 26.1007 20.797 26.0928H77.242C79.0037 26.1206 79.0389 28.8162 77.242 28.8439Z",
    fill: "url(#paint8_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.055 19.025H24.985L26.0827 13.9549H71.9577L73.055 19.025Z",
    fill: "url(#paint9_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.039 49.0016C98.0429 49.0413 6.5919e-06 48.9461 -0.0119934 48.962C0.0153506 48.851 0.0270696 48.7281 0.0270696 48.6052V43.3646H98.0111C98.0267 43.4162 97.9804 49.184 98.039 49.0016Z",
    fill: "url(#paint10_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25 71.2322V75.3826C70.25 76.6352 69.2344 77.6501 68 77.6501L30.039 77.654C28.8046 77.654 27.789 76.6353 27.789 75.3865V71.2361C27.789 69.9716 28.8046 68.9528 30.039 68.9528H68.004C69.2345 68.9488 70.25 69.9676 70.25 71.2322Z",
    fill: "url(#paint11_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.344 51.764H54.699V66.2017H43.344V51.764Z",
    fill: "url(#paint12_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.855 70.5746L11.7612 74.6417L11.4644 71.1771L11.855 70.5746Z",
    fill: "url(#paint13_linear_99_77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.535 70.9156L86.2381 74.6577L86.1443 70.5747L86.535 70.9156Z",
    fill: "url(#paint14_linear_99_77)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_77",
    x1: 48.9968,
    y1: 70.5746,
    x2: 48.9968,
    y2: 91.7631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_77",
    x1: 91.3592,
    y1: 62.1497,
    x2: 91.3592,
    y2: 70.2543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_77",
    x1: 91.3651,
    y1: 72.6796,
    x2: 91.3651,
    y2: 94.4146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_99_77",
    x1: 91.367,
    y1: 97.1651,
    x2: 91.367,
    y2: 100.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_99_77",
    x1: 6.64019,
    y1: 62.1497,
    x2: 6.64019,
    y2: 70.2514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_99_77",
    x1: 6.633,
    y1: 97.1651,
    x2: 6.633,
    y2: 100.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_99_77",
    x1: 6.63511,
    y1: 72.6752,
    x2: 6.63511,
    y2: 94.4146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_99_77",
    x1: 49.0194,
    y1: 0.203125,
    x2: 49.0194,
    y2: 40.6135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_99_77",
    x1: 49.0214,
    y1: 7.0769,
    x2: 49.0214,
    y2: 33.7391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_99_77",
    x1: 49.02,
    y1: 13.9549,
    x2: 49.02,
    y2: 19.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_99_77",
    x1: 49.0135,
    y1: 43.3646,
    x2: 49.0135,
    y2: 49.0114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_99_77",
    x1: 49.0196,
    y1: 68.9528,
    x2: 49.0196,
    y2: 77.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_99_77",
    x1: 49.0215,
    y1: 51.764,
    x2: 49.0215,
    y2: 66.2017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_99_77",
    x1: 11.6597,
    y1: 70.5746,
    x2: 11.6597,
    y2: 74.6417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_99_77",
    x1: 86.3397,
    y1: 70.5747,
    x2: 86.3397,
    y2: 74.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 101,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibitions);
export default __webpack_public_path__ + "static/media/Exhibitions.790d7ddff37e552ec0ba7d9291604293.svg";
export { ForwardRef as ReactComponent };